import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PinInputComponent } from './pin-input.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [PinInputComponent],
  imports: [CommonModule, IonicModule, TranslateModule, FormsModule],
  exports: [PinInputComponent]
})
export class PinInputModule {}
